import React from "react";
import styles from "./profile-title-hr.module.css";

const ProfileTitleHr = ({ label }) => {
  return (
    <div className={styles.profileTitleHrContainer}>
      <span className={styles.profileTitleLabel}>{label}</span>
      <hr className={styles.profileTitleLine} />
    </div>
  );
};

export default ProfileTitleHr;
